import React from 'react'
import { ReactComponent as EmptyDataIcon } from '../../../assets/svgs/no-data.svg'
import './no-data.scss'

interface INoData {
  icon?: React.ReactElement
  message: string
  child?: React.ReactElement
}
export const NoData = ({ message, child }: INoData) => {
  return (
    <section className="no-data">
      <EmptyDataIcon />
      <div className="body-sm message">
        {message}
        <div className="nav-head"> {child}</div>
      </div>
    </section>
  )
}

export default NoData
